import React, { useState } from 'react';
import styled, { css } from "styled-components";

const ButtonWrapper = styled.button`
	all: unset;
	display: ${(props) => props.style?.display ?? "flex"};
	box-sizing: border-box;
	font-family: ${(props) => props.style?.fontFamily ?? "pf_handbook_proregular"};
	font-weight: ${(props) => props.style?.fontWeight ?? "400"};
	font-size: ${(props) => props.style?.fontSize ?? "20px"}; // isMobile ? "1.6rem" : "",
	padding: ${(props) => props.style?.padding ?? "7px" }; // "0.75em 1em"
	text-align: center;
	color: ${(props) => props.style?.padding ?? "var(--color-white)"};
	${'' /* border: 15px solid blue; // var(--color-dirt_brown); */}
	width: 100%;
	min-width: fit-content;
	max-width: 100%;
	transition: 0.15s;
	width: ${(props) => (props.style?.width ? props.style?.width : "130px")};
	height: ${(props) => (props.style?.height ? props.style?.height : "40px")};
	margin: ${(props) => (props.style?.margin ? props.style?.margin : "auto")};	
	margin-top: ${(props) => (props.mobile ? "0px" : (props.style?.marginTop ? props.style?.marginTop : "10px"))};
	margin-bottom: 10px;
	${'' /* margin-bottom: ${(props) => (props.mobile ? "0px" : (props.style?.marginBottom ? props.style?.marginBottom : "20px"))}; */}
	background-color: ${(props) => (props.style?.marginBottom ? props.style?.marginBottom : "#CB3443")};
	border: "0px solid #CB3443";
	border-radius: ${(props) =>	props.style?.borderRadius ? props.style?.borderRadius : "15px"};
	box-shadow: ${(props) => props.style?.boxShadow
		? props.style?.boxShadow
		: "rgb(229 229 229) 1px 1px 11px, rgb(255, 255, 255) -1px -1px 17px"};
	${'' /* &:hover {
		cursor: pointer;
		background-color: var(--color-dirt_brown_dark);
	} */}
	&:focus {
		outline: none;
	}
	&:active {
		outline: none;
		transform: scale(0.95) !important;
	}
	&:disabled {
		color: var(--color-light_blue_grey);
		background-color:  grey; // var(--color-pale_grey);
		// border: 1.5px solid var(--color-pale_grey);
		cursor: not-allowed;
		box-shadow: none;
		${(props) => props.bordered &&
			css`
				color: var(--color-light_blue_grey);
				background-color: var(--color-white);
				border: 1.5px solid var(--color-light_blue_grey);
				&:hover {
					background-color: var(--color-white);
				}
			`};
	}

	.content {
		display: flex;
		flex-direction: ${(props) => props.style?.flexDirection ?? "column"};
		column-gap: ${(props) => props.style?.flexDirection === "row" ? "12px" : "0px"};
		justify-content: ${(props) => props.style?.flexDirection === "row" ? "flex-start" : "center"};
		text-align: center;
		width: 100%;
		height: 100%;
	}

	.text {
		width: 100%;
		color: white;
		font-family: ${(props) => props.style?.fontFamily ?? "pf_handbook_proregular"};
		font-weight: ${(props) => props.style?.fontWeight ?? "400"};
		font-size: ${(props) => props.style?.fontSize ?? "20px"};
	}

	${(props) => props.disabled &&
		css`
			.parent{
				all: unset;
				color: var(--color-light_blue_grey);
				background-color: grey; // var(--color-pale_grey);
				border: 1.5px solid var(--color-pale_grey);
				cursor: not-allowed;
				box-shadow: none;
			}
	`};

	${(props) =>
		props.bordered &&
		css`
			color: var(--color-tan_two);
			background-color: var(--color-white);
			border: 1.5px solid var(--color-tan_two);
			box-shadow: none;
			&:hover {
				background-color: var(--color-white);
			}
		`};

	${(props) =>
		props.mobile &&
		css`
			font-size: 1.2rem;
			padding: 0.75em 1em;
			margin-bottom: "0px"
		`};
`;

function Button(props) {
    const { onClick, onClickAdditional, disabled: propDisabled } = props
	const [loading, setLoading] = useState(false);
    const disabled = loading || propDisabled;

	const handleClick = async () => {
        setLoading(true);
        try {
            if (typeof onClick === 'function') {
                await onClick();
            }
            if (typeof onClickAdditional === 'function') {
                onClickAdditional();
            }
        } catch (error) {
            console.error('Error:', error);
        } finally {
            setLoading(false);
        }
    };
	
	return (
		<ButtonWrapper {...props} className="parent" onClick={handleClick} disabled={disabled}>
			<div className="content">
				{props.icon ? <div className="icon">{props.icon}</div> : <></>}
				<div className="text">{props.text}</div>
			</div>
		</ButtonWrapper>
	);
}

export default Button;
